import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-MeasurementPopup',
	header: 'c-MeasurementPopup__header',
	title: 'c-MeasurementPopup__title',
	headerActions: 'c-MeasurementPopup__headerActions',
	pauseButton: 'c-MeasurementPopup__pauseButton',
	closeButton: 'c-MeasurementPopup__closeButton',
	content: 'c-MeasurementPopup__content',
	emptyState: 'c-MeasurementPopup__emptyState',
	measurementRow: 'c-MeasurementPopup__measurementRow',
	measurementLabel: 'c-MeasurementPopup__measurementLabel',
	measurementValue: 'c-MeasurementPopup__measurementValue',
};

export const Style = {
	[CSS.container]: {
		position: 'absolute',
		bottom: DefaultTheme.space(2),
		left: '50%',
		transform: 'translateX(-50%)',
		background: '#ffffff',
		boxShadow: DefaultTheme.shadow.box.dp4,
		borderRadius: '8px',
		minWidth: '300px',
		maxWidth: '400px',
	},
	[CSS.header]: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(3)}`,
		borderBottom: `1px solid ${DefaultTheme.font.color.divider}`,
	},
	[CSS.title]: {
		fontSize: '16px',
		fontWeight: 600,
		color: DefaultTheme.font.color.primary,
	},
	[CSS.headerActions]: {
		display: 'flex',
		alignItems: 'center',
		gap: DefaultTheme.space(1),
	},
	[CSS.pauseButton]: {
		background: 'transparent',
		border: 'none',
		cursor: 'pointer',
		padding: `${DefaultTheme.space(0.5)} ${DefaultTheme.space(1)}`,
		fontSize: '13px',
		color: DefaultTheme.font.color.supporting,
		borderRadius: '4px',
		transition: 'background-color 0.15s',
		'&:hover': {
			backgroundColor: DefaultTheme.font.color.divider,
			color: DefaultTheme.font.color.primary,
		},
	},
	[CSS.closeButton]: {
		background: 'transparent',
		border: 'none',
		cursor: 'pointer',
		padding: DefaultTheme.space(1),
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: DefaultTheme.font.color.supporting,
		'&:hover': {
			color: DefaultTheme.font.color.primary,
		},
	},
	[CSS.content]: {
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(3)}`,
	},
	[CSS.emptyState]: {
		color: DefaultTheme.font.color.supporting,
		fontSize: '14px',
		textAlign: 'center',
		padding: DefaultTheme.space(2),
	},
	[CSS.measurementRow]: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: `${DefaultTheme.space(0.5)} 0`,
	},
	[CSS.measurementLabel]: {
		color: DefaultTheme.font.color.supporting,
		fontSize: '13px',
	},
	[CSS.measurementValue]: {
		color: DefaultTheme.font.color.primary,
		fontSize: '13px',
		fontWeight: 500,
		userSelect: 'text',
	},
};
